module.exports = __webpack_public_path__ + "static/video-3-17ad4a2bda99f8d163eb128ae412744e.mp4";